import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/apiServices';
 

// Async thunks for API calls
export const fetchDevices = createAsyncThunk('devices/fetchDevices', async () => {
  const response = await apiService.get('devices');
  return response.data;
});

export const createDevice = createAsyncThunk('devices/createDevice', async (deviceData) => {
  const response = await apiService.post('devices', deviceData);
  return response.data;
});

export const updateDevice = createAsyncThunk('devices/updateDevice', async ({ id, deviceData }) => {
  const response = await apiService.put(`devices/${id}`, deviceData);
  return response.data;
});

export const deleteDevice = createAsyncThunk('devices/deleteDevice', async (id) => {
  await apiService.delete(`devices/${id}`);
  return id;
});

export const checkSerialNumber = createAsyncThunk('devices/checkSerialNumber', async (serialNumber) => {
  const response = await apiService.get(`devices/check-serial/${serialNumber}`);
  return response.data.exists;
});

// Initial state
const initialState = {
  devices: [],
  loading: false,
  error: null,
  serialNumberExists: false,
};

// Device slice
const deviceSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    resetSerialNumberCheck: (state) => {
      state.serialNumberExists = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDevices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDevices.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = action.payload;
      })
      .addCase(fetchDevices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.devices.push(action.payload);
      })
      .addCase(createDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDevice.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.devices.findIndex((device) => device._id === action.payload._id);
        if (index !== -1) {
          state.devices[index] = action.payload;
        }
      })
      .addCase(updateDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = state.devices.filter((device) => device._id !== action.payload);
      })
      .addCase(deleteDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(checkSerialNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkSerialNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.serialNumberExists = action.payload;
      })
      .addCase(checkSerialNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetSerialNumberCheck } = deviceSlice.actions;

export default deviceSlice.reducer;